// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"introCard_wrapper__9o1a3","title":"introCard_title__RFaWN","previewImg":"introCard_previewImg__2D06u","link":"introCard_link___JS2u"};